module.exports = __webpack_public_path__ + "img/metodos-pago-bco.9d8bb8ce.svg";